import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=73da1048&"
import script from "./form-edit.vue?vue&type=script&lang=js&"
export * from "./form-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports